<div class="modal-header">
  <h3 class="modal-title">Cập nhật ảnh đại diện</h3>
  <button class="close" (click)="this.onClose()">
    <span aria-hidden="true"><i class="fal fa-times"></i></span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    
<!-- col-md-auto col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0 text-center -->


    <div class="col">
      <div class="note text-muted mb-4">
        <span class="">- File không được vượt quá 5 MB.</span>
        <br />
        <span class="">- Định dạng phù hợp: PNG, JPG, JPEG.</span>
      </div>
    </div>
  </div>

  <input
    type="file"
    #fileUpload
    (change)="fileChangeEvent($event)"
    class="d-none"
  />
  <div class="row">
    <div class="col order-2 order-lg-1">
      <div class="image-upload-container">
        @if(this.isOnInit) {
        <div (click)="fileUpload.click()">
          <div class="placeholder-avatar"></div>
          <div class="placeholder-text text-center fs-lg">
            <i class="fal fa-camera-alt fa-3x"></i>
            <br />
            Upload hình ảnh
          </div>
        </div>
        }@else { @if (this.isProcessingImage) {
        <!-- <div class="placeholder-avatar"></div> -->
        <div
          class="position-absolute transform-center top-center left-center text-center"
          style="z-index: 2"
        >
          <i class="spinner-border spinner-border-sm fs-lg"></i>
          <br />
          Upload hình ảnh
        </div>
        }
        <div
          class=""
          image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1"
          format="png"
          [alignImage]="'center'"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded($event)"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
        ></div>
        }
      </div>
      @if (!this.isOnInit) {
      <div class="mx-auto text-center mt-2">
        <a
          href="javascript:void(0)"
          (click)="fileUpload.click()"
          class="hover-underline"
          >Chọn ảnh khác</a
        >
      </div>
      }
    </div>
    
    
    <div class="col-md-auto col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0 text-center">
      <div class="image-preview-container d-inline-block">
        <div class="text-center mb-1 text-muted">
          @if (this.isProcessingImage) {
          <i class="spinner-border spinner-border-sm fs-lg"></i>
          } Xem trước
        </div>
        <div class="thumbnail__group">
          <img
            [src]="croppedImage"
            onerror="this.src='assets/img/logo.png'"
            alt="Avatar placeholder"
            class="thumbnail__group-avatar"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-center align-items-center">
  <button
    class="btn btn-outline-default m-0 mr-3 waves-effect waves-themed"
    (click)="this.onClose()"
  >
    Quay lại
  </button>
  <button
    class="btn btn-primary m-0 waves-effect waves-themed"
    [disabled]="
      this.isSaving ||
      !(this.croppedImage && this.croppedImageBlob) ||
      showErrorLoadImaged
    "
    [ngClass]="{
      'cursor-default':
        this.isSaving ||
        !(this.croppedImage && this.croppedImageBlob) ||
        showErrorLoadImaged
    }"
    (click)="onSubmit()"
    style="width: 9rem"
  >
    <span
      *ngIf="isSaving"
      class="spinner-grow spinner-grow-sm mr-1"
      role="status"
      aria-hidden="true"
    ></span>
    Cập nhật
  </button>
</div>
